(function () {
  const declinedKey = "akkoProtectionDeclined";
  const selectors = {
    widget: "[data-akko-protection]",
    input: ".akko-protection-widget__input",
    tile: "[data-akko-plan-tile]",
    error: "[data-akko-error]",
    cleanup: "[data-akko-cleanup]",
  };

  function routesRoot() {
    return window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : "/";
  }

  function isDeclined() {
    return (
      window.sessionStorage && sessionStorage.getItem(declinedKey) === "true"
    );
  }

  function setDeclined(value) {
    if (!window.sessionStorage) return;

    if (value) {
      sessionStorage.setItem(declinedKey, "true");
    } else {
      sessionStorage.removeItem(declinedKey);
    }
  }

  function parseResponseError(error) {
    if (!error) return "Unable to update protection. Please try again.";
    if (error.description) return error.description;
    if (error.message) return error.message;
    return "Unable to update protection. Please try again.";
  }

  function setCheckoutLoading(widget, loading) {
    document.querySelectorAll(".cart__checkout").forEach((btn) => {
      btn.classList.toggle("btn--loading", loading);
      btn.disabled = loading;
    });
  }

  function waitForSubtotalUpdate(timeoutMs) {
    return new Promise((resolve) => {
      const subtotal = document.querySelector("[data-subtotal]");
      if (!subtotal) {
        resolve();
        return;
      }
      const observer = new MutationObserver(() => {
        clearTimeout(timer);
        observer.disconnect();
        resolve();
      });
      const timer = setTimeout(() => {
        observer.disconnect();
        resolve();
      }, timeoutMs || 3000);
      observer.observe(subtotal, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    });
  }

  function setError(widget, message) {
    const error = widget && widget.querySelector(selectors.error);
    if (!error) return;

    if (message) {
      error.textContent = message;
      error.hidden = false;
    } else {
      error.textContent = "";
      error.hidden = true;
    }
  }

  function getLineAkkoProperty(item) {
    return (
      item && item.properties && item.properties._akko_protection === "true"
    );
  }

  async function getCart() {
    const response = await fetch(`${routesRoot()}cart.js`, {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
      },
    });
    return response.json();
  }

  async function addPlan(variantId, properties) {
    if (!variantId) return null;

    const cart = await getCart();
    const existing = cart.items.find((item) => {
      return (
        String(item.variant_id) === String(variantId) &&
        getLineAkkoProperty(item)
      );
    });

    if (existing) return existing;

    const response = await fetch(`${routesRoot()}cart/add.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: Object.assign(
              {
                _akko_protection: "true",
              },
              properties || {},
            ),
          },
        ],
      }),
    });
    const data = await response.json();

    if (!response.ok) throw data;

    return data;
  }

  async function removePlan(lineKey) {
    if (!lineKey) return null;

    const response = await fetch(`${routesRoot()}cart/change.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0,
      }),
    });
    const data = await response.json();

    if (!response.ok) throw data;

    return data;
  }

  function refreshCart(cart) {
    document.dispatchEvent(new CustomEvent("cart:build"));

    if (cart) {
      document.dispatchEvent(
        new CustomEvent("cart:updated", {
          detail: { cart },
        }),
      );
    }
  }

  function getCheckedInput(widget) {
    if (!widget) return null;
    return widget.querySelector(`${selectors.input}:checked`);
  }

  function getRecommendedInput(widget) {
    if (!widget) return null;
    const index = parseInt(widget.dataset.akkoRecommendedIndex || "0", 10);
    if (!index) return null;
    return widget.querySelector(
      `${selectors.input}[data-akko-plan-index="${index}"]`,
    );
  }

  function getSelectedPlanVariantId(scope) {
    let widget = scope && scope.querySelector(selectors.widget);

    // The widget can be a standalone theme-editor block rendered as a
    // sibling of the product form, so fall back to the enclosing section.
    if (!widget && scope && scope.closest) {
      const sectionEl = scope.closest(".shopify-section");
      widget =
        sectionEl &&
        sectionEl.querySelector(
          `${selectors.widget}[data-akko-context="product"]`,
        );
    }

    if (!widget) return null;

    const checked = getCheckedInput(widget);
    if (!checked) return null;

    return checked.dataset.akkoPlanVariantId || null;
  }

  function syncTileCheckedClass(widget) {
    widget.querySelectorAll(selectors.input).forEach((input) => {
      const tile = input.closest(selectors.tile);
      if (!tile) return;
      tile.classList.toggle(
        "akko-protection-widget__plan--checked",
        input.checked,
      );
    });
  }

  function setInputsDisabled(widget, disabled) {
    widget
      .querySelectorAll(selectors.input)
      .forEach((input) => (input.disabled = disabled));
  }

  async function findCartLineForVariant(variantId) {
    const cart = await getCart();
    return cart.items.find(
      (item) =>
        String(item.variant_id) === String(variantId) &&
        getLineAkkoProperty(item),
    );
  }

  async function handleCartPlanChange(widget, newVariantId) {
    const oldLineKey = widget.dataset.akkoCartLineKey;

    setInputsDisabled(widget, true);
    setError(widget);
    setCheckoutLoading(widget, true);

    try {
      setDeclined(false);

      if (oldLineKey) {
        await removePlan(oldLineKey);
      }

      await addPlan(newVariantId);

      const newLine = await findCartLineForVariant(newVariantId);
      widget.dataset.akkoCartLineKey = newLine ? newLine.key : "";

      const cart = await getCart();
      const subtotalUpdated = waitForSubtotalUpdate();
      refreshCart(cart);
      await subtotalUpdated;
    } catch (error) {
      setError(widget, parseResponseError(error));
    } finally {
      setInputsDisabled(widget, false);
      setCheckoutLoading(widget, false);
      syncTileCheckedClass(widget);
    }
  }

  async function handleCartPlanRemove(widget) {
    const lineKey = widget.dataset.akkoCartLineKey;
    if (!lineKey) return;

    setInputsDisabled(widget, true);
    setError(widget);
    setCheckoutLoading(widget, true);

    try {
      await removePlan(lineKey);
      widget.dataset.akkoCartLineKey = "";

      const cart = await getCart();
      const subtotalUpdated = waitForSubtotalUpdate();
      refreshCart(cart);
      await subtotalUpdated;
    } catch (error) {
      setError(widget, parseResponseError(error));
    } finally {
      setInputsDisabled(widget, false);
      setCheckoutLoading(widget, false);
      syncTileCheckedClass(widget);
    }
  }

  function initWidget(widget) {
    if (widget.dataset.akkoInitialized === "true") return;

    const inputs = widget.querySelectorAll(selectors.input);
    if (!inputs.length) return;

    const context = widget.dataset.akkoContext || "";
    const isCartContext = context.indexOf("cart") !== -1;

    if (isDeclined() && !isCartContext && !widget.dataset.akkoCartLineKey) {
      inputs.forEach((input) => (input.checked = false));
      syncTileCheckedClass(widget);
    }

    inputs.forEach((input) => {
      const tile = input.closest(selectors.tile);
      let wasChecked = false;

      const recordState = () => {
        wasChecked = input.checked;
      };

      const handleClick = (event) => {
        if (!wasChecked) return;
        event.preventDefault();
        input.checked = false;
        syncTileCheckedClass(widget);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      };

      if (tile) {
        tile.addEventListener("pointerdown", recordState);
        tile.addEventListener("mousedown", recordState);
        tile.addEventListener("click", handleClick);
      }

      input.addEventListener("change", () => {
        if (!input.checked) {
          // Only the toggle-off click dispatches change on an unchecked
          // radio, so this is always an explicit opt-out.
          setDeclined(true);
          syncTileCheckedClass(widget);

          if (isCartContext) {
            handleCartPlanRemove(widget);
          }
          return;
        }
        setDeclined(false);
        syncTileCheckedClass(widget);

        if (isCartContext) {
          handleCartPlanChange(widget, input.dataset.akkoPlanVariantId);
        }
      });
    });

    widget.dataset.akkoInitialized = "true";
  }

  function initCleanup() {
    document.querySelectorAll(selectors.cleanup).forEach((element) => {
      const lineKey = element.dataset.akkoCartLineKey;
      if (!lineKey || element.dataset.akkoInitialized === "true") return;

      element.dataset.akkoInitialized = "true";
      removePlan(lineKey)
        .then(getCart)
        .then(refreshCart)
        .catch(() => {});
    });
  }

  function init() {
    document.querySelectorAll(selectors.widget).forEach(initWidget);
    initCleanup();
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("cart:build", () => window.setTimeout(init, 100));
  document.addEventListener("shopify:section:load", () =>
    window.setTimeout(init, 100),
  );
  document.addEventListener("ajaxProduct:added", () =>
    window.setTimeout(init, 100),
  );

  document.addEventListener("product-form:cart:request", async (event) => {
    const formElement = event.target;
    const variantId = getSelectedPlanVariantId(formElement);

    if (!variantId) return;

    event.preventDefault();

    try {
      await addPlan(variantId, {
        _akko_parent_variant: String(event.detail.form.get("id") || ""),
      });

      const response = await fetch(
        `${routesRoot()}cart/add.js`,
        event.detail.config,
      );
      const data = await response.json();

      if (!response.ok) throw data;

      event.detail.resolve(data);
    } catch (error) {
      event.detail.reject(error);
    }
  });

  window.AkkoProtection = {
    addPlan,
    getSelectedPlanVariantId,
    init,
    removePlan,
    setDeclined,
  };
})();
